// extracted by mini-css-extract-plugin
module.exports = {"confirmDialog":"confirmDialog_confirmDialog__2dIdy"};